exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.main[data-v-ce899c7c] {\n  padding: 0 6% 0 5%;\n}\n.top[data-v-ce899c7c] {\n  top: .25rem;\n}\n.logo[data-v-ce899c7c] {\n  height: 12em;\n  width: 12em\n}\n.need-help[data-v-ce899c7c] {\n  font-size: 14px;\n  margin-right: 1.3rem;\n}\n.pos-absolute[data-v-ce899c7c] {\n  position: absolute;\n}\n@media screen and (max-width: 500px) {\n.right-button[data-v-ce899c7c] {\n    -webkit-box-pack: end;\n        -ms-flex-pack: end;\n            justify-content: flex-end;\n}\n.logo[data-v-ce899c7c] {\n    height: 8em;\n    width: 8em\n}\n.need-help[data-v-ce899c7c] {\n    font-size: 10px;\n}\n}\n@media screen and (max-width: 300px) {\n.logo[data-v-ce899c7c] {\n    height: 5em;\n    width: 5em\n}\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-ce899c7c","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/AkkoHeader.vue
// module id = 650
// module chunks = 0